import { Reveal } from "@/components/Reveal";
import { INDUSTRIES } from "@/data/content";

export default function IndustriesGrid() {
  return (
    <div data-testid="industries-grid" className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
      {INDUSTRIES.map((ind, i) => (
        <Reveal key={ind.title} delay={Math.min(i * 0.06, 0.36)} className="h-full">
          {ind.image ? (
            <div data-testid={`industry-card-${i + 1}`} className="group relative h-full min-h-[320px] lg:min-h-[380px] overflow-hidden bg-oxford">
              <img
                src={ind.image}
                alt={ind.alt}
                loading="lazy"
                className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-oxford via-oxford/40 to-oxford/10" />
              <span className="absolute top-0 left-0 h-[2px] w-0 bg-gold transition-all duration-500 group-hover:w-full z-10" />
              <div className="relative h-full flex flex-col justify-end p-7">
                <ind.icon className="h-6 w-6 text-gold" strokeWidth={1.5} />
                <h3 className="mt-4 font-display text-base font-semibold uppercase tracking-wide text-white leading-snug">{ind.title}</h3>
                <p className="mt-2 text-sm text-steel">{ind.desc}</p>
              </div>
            </div>
          ) : (
            <div
              data-testid={`industry-card-${i + 1}`}
              className="group relative h-full min-h-[320px] lg:min-h-[380px] bg-oxford diagonal-lines border border-oxford p-7 flex flex-col justify-between transition-all duration-300 hover:-translate-y-1"
            >
              <span className="absolute top-0 left-0 h-[2px] w-0 bg-gold transition-all duration-500 group-hover:w-full" />
              <ind.icon className="h-8 w-8 text-gold" strokeWidth={1.25} />
              <div>
                <h3 className="font-display text-base font-semibold uppercase tracking-wide text-white leading-snug">{ind.title}</h3>
                <p className="mt-2 text-sm text-steel">{ind.desc}</p>
              </div>
            </div>
          )}
        </Reveal>
      ))}
      <Reveal delay={0.4} className="h-full">
        <div className="relative h-full min-h-[320px] lg:min-h-[380px] bg-white border border-oxford/10 p-7 flex flex-col justify-between">
          <span className="font-display text-[10px] font-semibold tracking-[0.3em] uppercase text-gold">BRIK</span>
          <div>
            <p className="font-display text-xl font-semibold text-oxford leading-snug">
              Distintas industrias. <span className="text-gold">Una sola visión.</span>
            </p>
            <p className="mt-3 text-sm leading-relaxed text-carbon/70">
              Entendemos sus retos y generamos soluciones de valor.
            </p>
          </div>
        </div>
      </Reveal>
    </div>
  );
}
